import { Model } from "./model";

export class QuestionnaireAnswer extends Model {
	private sort: number = 0;
	private label: string = "";
	private answer: string = "";
	private valid: boolean = false;
	private selected: boolean = false;

	public getSort(): number {
		return this.sort;
	}

	public getLabel(): string {
		return this.label;
	}

	public getAnswer(): string {
		return this.answer;
	}

	public isValid(): boolean {
		return this.valid;
	}

	public isSelected(): boolean {
		return this.selected;
	}

	public setSelected(b: boolean): void {
		this.selected = b;
	}
}
